<template>
  <div class="product-template __donate  __limited-edu __velaa">
    <div class="container pd-sm-0">
      <div class="col-md-push-2 col-md-8">
        <div class="text-center mb-10">
            <img src="/static/img/velaa/VELAA_03-Black.gif" alt="Velaa Langsuan" width="190px" class="pd-15 ma-auto d-block" />
          <h1 class="page-title text-center">Velaa Langsuan</h1>
        </div>
        <h3 class="text-center mb-20 pb-20">It’s Time to Celebrate and Be Kind!</h3>
    </div>
    </div>
    <div class="container pd-sm-0">
      <div class="col-md-push-2 col-md-8 col-lg-push-2 ">
        <div class="product product--inline">
          <div class="product__block--form">
            <div class="radius block shadow bg-gray">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />
              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />
              <div class="text-center _pt-20">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">กดเลือกบริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  export default {
    name: 'uob lovestory',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        attributes: {
          info: {
            name: ''
          }
        }
      }
    },

    methods: {
      donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        this.$store.dispatch('clearCart').then(() => {
          this.$refs.cartAction.buyNow()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.product-template.__velaa {
    background: white !important;
}
.bg-gray {
    background-color: #f5f5f5 !important;
}
  h1.page-title {
    color: #000;
    font-size: 1.85em;
    font-weight: 500;
    margin-bottom: 15px;
  }
  h3 {
    color:#000;
  }
  .text-primary {
    color: #000;
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }
  
</style>



// WEBPACK FOOTER //
// custom-velaa.vue?0cd72644